// @flow
import type { LangInfo } from "@kiwicom/nitro/lib/records/LangInfo"

export const DEFAULT_FONT_FAMILY_CSS: string =
  '"Circular Pro",' +
  ' -apple-system, ".SFNSText-Regular", "San Francisco", "Segoe UI", "Helvetica Neue", "Lucida Grande", ' +
  "sans-serif"

const getFontFamilyCssFromLanguage = ({ language }: { language: LangInfo }): string =>
  language.specialFont
    ? `\"${language.specialFont}\", ${DEFAULT_FONT_FAMILY_CSS}`
    : `${DEFAULT_FONT_FAMILY_CSS}`

export default getFontFamilyCssFromLanguage
